export default "__VITE_ASSET__CKsG9o5v__"